(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-promo-clicable"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gc-banner-promo')) {
    customElements.define('gc-banner-promo', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.editor = this.dataset.editor === 'true';
        this.key = 'gc-banner-promo:' + location.hostname + ':' + this.dataset.campaign;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('button').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        }, options);
        this.querySelector('a').addEventListener('click', () => this.remember(), options);
        this.dialog.addEventListener('close', () => {
          this.remember();
          if (this.previousFocus?.isConnected) this.previousFocus.focus();
        }, options);
        if (this.editor) {
          document.addEventListener('shopify:section:select', event => {
            if (event.target.contains(this)) this.open();
          }, options);
          document.addEventListener('shopify:section:deselect', event => {
            if (event.target.contains(this) && this.dialog.open) this.dialog.close();
          }, options);
        }
        this.timer = setTimeout(() => this.open(), this.editor ? 400 : Number(this.dataset.delay));
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
      storage() { return this.dataset.frequency === 'session' ? sessionStorage : localStorage; }
      remember() {
        if (this.editor || this.dataset.frequency === 'always') return;
        try { this.storage().setItem(this.key, String(Date.now())); } catch (error) {}
      }
      allowed() {
        const mobile = matchMedia('(max-width: 749px)').matches;
        if (this.dataset.device === 'desktop' && mobile) return false;
        if (this.dataset.device === 'mobile' && !mobile) return false;
        const now = Date.now();
        const iso = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
        for (const field of ['start', 'end']) {
          const value = this.dataset[field];
          if (!value) continue;
          const time = Date.parse(value);
          if (!iso.test(value) || !Number.isFinite(time)) return false;
          if (field === 'start' && now < time) return false;
          if (field === 'end' && now >= time) return false;
        }
        if (this.dataset.frequency === 'always') return true;
        try {
          const seen = Number(this.storage().getItem(this.key));
          if (!seen) return true;
          if (this.dataset.frequency === 'session') return false;
          return now - seen >= Number(this.dataset.days) * 86400000;
        } catch (error) { return true; }
      }
      open() {
        if (!this.isConnected || this.dialog.open) return;
        if (!this.editor && !this.allowed()) return;
        if (document.querySelector('dialog[open]')) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.remember();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
